import { Trans, useTranslation } from "react-i18next";
import "@common/Login/css/Login.scss";
import { HOME_PAGE_URL } from "@constants";
import { ForgotEmailForm } from "@features/ForgotEmail/ForgotEmailForm";
import { ForgotEmailSuccess } from "@features/ForgotEmail/ForgotEmailSuccess";
import { forgotEmailStep } from "@features/ForgotEmail/interface/IForgotEmail";
import { useForgotEmail } from "@features/ForgotEmail/hook/useForgotEmail";
import { phoneRegex } from "@utils/formControl";
import { Card, CardContent, Grid, Link, Typography } from "@mui/material";

export const ForgotEmailPage = () => {
    const {
        checkVerificationCode,
        checkPhoneNumber,
        recoverEmail,
        actualStep,
        goToInitialStep,
        postVerificationCodeState,
        postPhoneNumberState,
    } = useForgotEmail();
    const { t } = useTranslation("forgotEmail");

    const isInitialStep = actualStep === forgotEmailStep.initial;
    const isVerificationCodeStep = actualStep === forgotEmailStep.verificationCode;
    const isSuccessStep = actualStep === forgotEmailStep.success;
    const isEmailNotVerifiedStep = actualStep === forgotEmailStep.emailNotVerified;

    return (
        <div className="container-boxed login__container">
            <Typography align="center" className="container-boxed__title" color="secondary" variant="h1">
                {t("forgotEmail")}
            </Typography>
            <Card className="login__card" elevation={2}>
                <CardContent>
                    <Grid alignItems="center" container justifyContent="center" spacing={2}>
                        <Grid item>
                            <div className="login__helper">
                                <Typography align="center" color="secondary" variant="normal">
                                    {isInitialStep && <Trans i18nKey="forgotEmailInit" ns="forgotEmail" />}
                                    {isVerificationCodeStep && t("verificationCodeTooltip")}
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            {isInitialStep && (
                                <ForgotEmailForm
                                    callState={postPhoneNumberState}
                                    handleFormSubmit={checkPhoneNumber}
                                    label={t("mobileNumber")}
                                    name="mobileNumber"
                                    type="tel"
                                    validate={phoneRegex}
                                />
                            )}
                            {isVerificationCodeStep && (
                                <ForgotEmailForm
                                    callState={postVerificationCodeState}
                                    goToInitialStep={goToInitialStep}
                                    handleFormSubmit={checkVerificationCode}
                                    label={t("verificationCode")}
                                    name="verificationCode"
                                    type="text"
                                />
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            {isSuccessStep && <ForgotEmailSuccess email={recoverEmail} isVerified />}
                            {isEmailNotVerifiedStep && <ForgotEmailSuccess email={recoverEmail} isVerified={false} />}
                        </Grid>
                        <Grid className="login__links" item>
                            <Link href={HOME_PAGE_URL}>
                                <Typography align="center" color="primary">
                                    {t("backLogin")}
                                </Typography>
                            </Link>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </div>
    );
};
